module.exports = __webpack_public_path__ + "assets/ef39a4e95a77186d8cb4b016822d1069.wav";